import { Component, OnDestroy, OnInit, AfterViewInit } from '@angular/core'
import { FormBuilder } from '@angular/forms'
import { Subject } from 'rxjs'
import { fadeIn } from '../../../animations/fadeIn'
import { KeyingStructureService } from '../../../services/keying.structure.service'
import { KeyingSystemService } from '../../../services/keying.system.service'
import { ErrorService } from '../../../services/error.service'
import { LoadingService } from '../../../services/loading.service'
import { KeySystemNavConfig } from '../../../configuration/key.system.nav.config'
import { KeySystem, Structure } from '../../../models/dev.test.models'
import { flatMap, filter, takeUntil, take } from 'rxjs/operators'

@Component({
    selector: 'app-order-detail',
    templateUrl: './order-detail.component.html',
    styleUrls: ['./order-detail.component.scss'],
    animations: [fadeIn],
    standalone: false
})
export class OrderDetailComponent implements OnInit, AfterViewInit, OnDestroy {
  destroy$ = new Subject()
  structure: Structure
  keySystem: KeySystem

  orderDetails: any

  public tabs = [
    { name: 'Orders', id: 0 },
    { name: 'Audit Trail', id: 1 },
  ]
  public selectedTab = this.tabs[0]
  public selectedTabIndex = 0
  sortBy = null
  isAsc = null

  constructor(
    private keyingStructureService: KeyingStructureService,
    private keyingSystemService: KeyingSystemService,
    private loadingService: LoadingService,
    public form: FormBuilder,
    private errorService: ErrorService,
    private keySystemNavConfig: KeySystemNavConfig
  ) {}

  /* istanbul ignore next */
  ngOnInit(): void {
    this.selectedTab = this.tabs[0]
    //  this.getOrderDetails(this.structure.id, this.keySystem.id)
    this.loadStructureAndKeySystem()
  }

  /* istanbul ignore next */
  ngAfterViewInit(): void {}

  /* istanbul ignore next */
  ngOnDestroy() {
    this.destroy$.next(true)
    this.destroy$.complete()
  }
  /* istanbul ignore next */
  loadStructureAndKeySystem() {
    this.keyingStructureService.structure$
      .pipe(
        filter((structure) => !!structure),
        takeUntil(this.destroy$),
        flatMap((structure: Structure) => {
          this.structure = structure
          return this.keyingSystemService.keySystem$
        })
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (keySystem: KeySystem) => {
          this.keySystem = keySystem
          // return this.keyingStructureService.orderDetails$
          if (this.structure && this.keySystem) {
            this.keySystemNavConfig.setNav('AuditTrail', this.structure, this.keySystem)
            this.getOrderDetails(this.structure.id, this.keySystem.id)
          }
        },
        (error) => {
          this.errorService.throw(error)
        }
      )
  }

  /* istanbul ignore next */
  onChangeTab(tab) {
    this.selectedTabIndex = tab.index
    this.selectedTab = this.tabs[tab.index]
  }

  /* istanbul ignore next */
  getOrderDetails(structureId: number, keySystemId: number) {
    this.loadingService.set({ isLoading: true, message: 'Getting Order Details' })
    this.keyingStructureService
      .getStructureOrderDetail(structureId, keySystemId)
      .pipe(take(1))
      .subscribe((result) => {
        this.loadingService.set({ isLoading: false, message: '' })
        this.orderDetails = result
        // this.keyingStructureService.setOrderDetails(result)
      })
  }
}
